@if (isLoading) {
    <div class="fancy-loader"></div>
} @else {
    <div>
        <form-linkable
            displayValueProp="name"
            [linkedModule]="linkedModule"
            [linked]="linked"
            [unlinked]="unlinked"
            [disabled]="disabled"
            [hideActions]="true"
            (linkedChange)="linkedItemsChanged($event)"
            data-uiid="auditforms-linkable"
        ></form-linkable>
    </div>
}
